import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListTagsComponent } from './components/list-tags/list-tags.component';
import { AddTagsComponent } from './components/add-tags/add-tags.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UiModule } from 'src/app/ui/ui.module';



@NgModule({
  declarations: [
    ListTagsComponent,
    AddTagsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
  ]
})
export class TagsModule { }
